import MyLearningPanel from '../components/my-learning-panel';

export default class MyLearningFlyoutController {
  /* @ngInject */
  constructor($scope) {
    $scope.MyLearningPanel = MyLearningPanel;
  }
}
